import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PersonalInformation, VueReadOnlyFormItem, VueTranslationService } from '@vue/vueframework';

@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  standalone: false
})
export class PersonalInformationComponent implements OnInit {
  public items: VueReadOnlyFormItem[] = [];
  public personalInfo: PersonalInformation;
  public translationKeys = [
    'field.firstName',
    'field.lastName',
    'field.email',
    'field.Username',
    'label.VueId'
  ];
  public translations: Record<string, string> = {};
  public vueId: number;
  private vueIdLabel: string;
  public constructor(
    private route: ActivatedRoute,
    private vueTranslationService: VueTranslationService
  ) { }

  public ngOnInit(): void {
    this.personalInfo = this.route.snapshot.data.personalInformation;
    this.vueId = this.route.snapshot.data.vueId;
    this.translations = this.vueTranslationService.getTranslations('PortalBase',
      this.translationKeys);
    this.vueIdLabel = this.vueTranslationService.getTranslation('Connect', 'label.VueId');
    this.setPersonalInformation();
  }

  public setPersonalInformation(): void {
    this.items.push(
      new VueReadOnlyFormItem()
        .setName(this.translations[ 'field.firstName' ])
        .setValue(this.personalInfo.firstName)
    );
    this.items.push(
      new VueReadOnlyFormItem()
        .setName(this.translations[ 'field.lastName' ])
        .setValue(this.personalInfo.lastName)
    );
    this.items.push(
      new VueReadOnlyFormItem()
        .setName(this.translations[ 'field.email' ])
        .setValue(this.personalInfo.emailAddress)
    );
    this.items.push(
      new VueReadOnlyFormItem()
        .setName(this.translations[ 'field.Username' ])
        .setValue(this.personalInfo.username)
    );
    this.items.push(
      new VueReadOnlyFormItem()
        .setName(this.vueIdLabel)
        .setValue(this.vueId?.toString())
    );
  }
}
